import { render, staticRenderFns } from "./maintenanceContact.vue?vue&type=template&id=c1b0c506&scoped=true"
import script from "./maintenanceContact.vue?vue&type=script&lang=js"
export * from "./maintenanceContact.vue?vue&type=script&lang=js"
import style0 from "./maintenanceContact.vue?vue&type=style&index=0&id=c1b0c506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b0c506",
  null
  
)

export default component.exports